import React, { Component } from 'react';
import { connect } from 'react-redux'
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import {toastr} from 'react-redux-toastr'
import { MODAL_VIDE_INFO, hideModal } from '../../../../modules/modals';

class VideoModal extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  handleClose = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : MODAL_VIDE_INFO});

  }

  getTitle = () => {
    const {formatMessage} = this.context;

    const {titleModal} = this.props; 

    return <div className="create-dialog-modal-content__title">{formatMessage(titleModal)}</div>;
  }

  render() {
    const {formatMessage} = this.context
    const { zIndex, messageModal, videoUrl } = this.props;
    return (
      <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
      >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body" style={{padding: '5px 20px 0px'}}>
            <form className="create-dialog-form">
              <div className="row mb-5">
                <div className="col-xs-12 text-center" style={{marginBottom: 20}}>
                  {formatMessage(messageModal)}
                </div>
           
                <div className="col-xs-12">
                  <video style={{width: '100%'}} controls >
                    <source src={videoUrl} />
                  </video>
                </div>
              </div>
              {/* <div className="create-dialog-form__group flex">
                <button className="btn btn-primary mr-auto" type="submit">{formatMessage('btnModalDelete')}</button>
                <button className="btn btn-warning" type="button" onClick={() => {
                  this.handleClose();
                }}>{formatMessage('btnModalCancel')}</button>
              </div> */}
            </form>
          </div>
      </Modal>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
})

const mapDispatchToProps = {
  hideModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoModal)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentations/components/VideoModal/index.jsx